module.exports = __webpack_public_path__ + "static/media/recruitment-img2.cf408ee4.png";